import { List } from "./list";
import { cr } from "fire-wind-water";

class Radio extends List {
  constructor(field: { [label: string]: any }) {
    super(field);
  }

  setValue(id?: { [label: string]: any }): void {
    const val = this.listOptions.filter((d) => {
      return d.optionId === id;
    })[0];
    this.value = val ? [val.optionValue] : [];
    this.label = val ? [val.optionId] : [];
    this.model = val || [];
    this.otherValue = [];
    if (val && val.otherisFillIn == 1) {
      this.otherValue.push({ [val.optionValue]: val.otherValue });
    }
    cr.each(this.listOptions, (d) => {
      d.checked = this.value.indexOf(d.optionValue) !== -1;
    });
    this.dirty = true;
    this.isError();
  }

  initValue(o): void {
    this.value = o.value || [];
    this.otherValue = o.otherValue || [];
    this.model = [];
    this.label = [];
    this.dirty = false;
    this.isError();
    this.initModel();
  }
}

export { Radio };
